/**
 * Coupure (liste commandes) — clés API = valeurs ENUM MySQL.
 */
export const COUPURE_OPTIONS = [
  { value: 'epoptique', label: 'Epoptique' },
  { value: 'externe', label: 'Externe' },
  { value: 'epoptique_a', label: 'Epoptique A' },
  { value: 'epoptique_s', label: 'Epoptique S' },
  { value: 'epoptique_w', label: 'Epoptique W' },
];
